<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="700px"
  >
    <template v-slot:activator="{ on:dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            icon
            v-on="{ ...dialog, ...tooltip }"
          >
            <v-icon color="grey">
              mdi-cached
            </v-icon>
          </v-btn>
        </template>
        <span>Compute For Missing Employees</span>
      </v-tooltip>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Payroll Statutories"
      text="Compute for missing company employees"
      class="mb-0"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-card-text>
            Compute for these company employees?
            <v-list dense>
              <v-list-item
                v-for="missingCompanyEmployeesStatutory in missingCompanyEmployeesStatutories"
                :key="missingCompanyEmployeesStatutory.company_employee_uid"
              >
                {{ missingCompanyEmployeesStatutory.employee.person.name + ' (' + missingCompanyEmployeesStatutory.company.name + ')' }}
              </v-list-item>
            </v-list>
          </v-card-text>     
        </v-container>
      </form>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="closeDialog"
        >
          No
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"  
          class="white--text px-10"
          @click="submitForm"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      missingCompanyEmployeesStatutories: {
        type: Array,
        required: true,
      },
      payrollCycleTransaction: {
        type: Object,
        required: true,
      },
    },    
    data () {
      return {
        loading: false,
        progressing: false,
        dialog: null,
      }
    },
    methods: {
      submitForm () {
        this.progressing = true
        this.$api.payrollCycleTransactions().compute(this.payrollCycleTransaction.id, this.prepareFormData())
          .then(res => {
            if (res.status === 200 || res.status === 201) {
              this.dialog = false
              this.$emit('computed')
            }
          })
          .catch(() => {
            this.$snack({ color: 'error', message: 'Error! Unable to compute.' })
          })
          .then(() => {
            this.progressing = false
          }) 
      },      
      closeDialog () {
        this.dialog = false
      },
      prepareFormData () {
        let data = []

        this.missingCompanyEmployeesStatutories.map(employee => {
          data.push({ payroll_cycle_employee_id: employee.payroll_cycle_employees[0].id, company_employee_uid: employee.company_employee_uid, status: employee.payroll_cycle_employees[0].status })
        })

        return {
          data: data,
        }
      },
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:5px
}
</style>
